import React, { useEffect, useState } from "react";


import { Container, Typography, Paper } from "@mui/material";
import { useAuth } from "../authContext"; // Assuming authentication is implemented

import { collection, getDocs, query, where, getFirestore } from "firebase/firestore";
import { getApp } from "firebase/app";

const db = getFirestore(getApp()); // Fetch the existing Firebase instance


const TeamManagerPage = () => {
    const { user, loading } = useAuth(); // This should return the logged-in user's name
    
    if (loading) return <div>Loading...</div>;
    if (!user) return <Navigate to="/login" />;

    const [clients, setClients] = useState([]);
    const companyName = "KHR CO Limited"; // Adjust this as needed

    useEffect(() => {
        const fetchClients = async () => {
            try {
                if (!user) return;

                const clientsRef = collection(db, "companies", companyName, "clients");
                const q = query(clientsRef, where("teamManager", "==", user.name));
                const clientSnapshot = await getDocs(q);
                const clientList = clientSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setClients(clientList);
            } catch (error) {
                console.error("Error fetching clients:", error);
            }
        };

        fetchClients();
    }, [user]);

    return (
        <Container>
            <Typography variant="h4">Team Manager Dashboard</Typography>
            {clients.length > 0 ? (
                clients.map((client) => (
                    <Paper key={client.id} sx={{ padding: 2, marginBottom: 2 }}>
                        <Typography variant="h6">{client["name of client"]} ({client["type of work"]})</Typography>
                        <Typography>Team Members: {client.teamMembers.join(", ")}</Typography>
                    </Paper>
                ))
            ) : (
                <Typography>No clients assigned to you.</Typography>
            )}
        </Container>
    );
};

export default TeamManagerPage;
